/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Ourcompany_Pointone2Inputs */

const ja_company_ourcompany_pointone2 = /** @type {(inputs: Company_Ourcompany_Pointone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは、ゲームカルチャーをより多くの人々と共有したいという想いから2016年に設立されました。`)
};

const en_company_ourcompany_pointone2 = /** @type {(inputs: Company_Ourcompany_Pointone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN was born out of a desire to share game culture.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN was born out of a desire to share game culture." |
*
* @param {Company_Ourcompany_Pointone2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_ourcompany_pointone2 = /** @type {((inputs?: Company_Ourcompany_Pointone2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Ourcompany_Pointone2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_ourcompany_pointone2(inputs)
	return en_company_ourcompany_pointone2(inputs)
});
export { company_ourcompany_pointone2 as "company_ourCompany_pointOne" }